import React from "react";
import Home from "./components/Home";

const App = () => {
  return (
    <div className="bg-black h-full w-full">
      <Home />
    </div>
  );
};

export default App;
